// @flow

export const INIT_LOAD = 'INIT_LOAD'
export const INIT_LOADED = 'INIT_LOADED'
export const INIT_ERROR = 'INIT_ERROR'
export const UPDATE_COUNTERS = 'UPDATE_COUNTERS'
export const UPDATE_COUNTERS_SUCCESS = 'UPDATE_COUNTERS_SUCCESS'
export const TRANSLATIONS_UPDATE = 'TRANSLATIONS_UPDATE'
export const EMAIL_ACCOUNT_FONT_UPDATE = 'EMAIL_ACCOUNT_FONT_UPDATE'
